<template>
	<div class="saved-to-spend-balance">
		<div class="top-card">
			<div class="main-content">
				<div class="header-section">
					<p class="title">{{ title }}</p>
					<div class="balance-row">
						<img :src="require('@/assets/icons/coins-swap.png')" alt="coins" class="balance-icon" />
						<p class="balance">{{ formattedBalance }}</p>
					</div>
				</div>
				<div class="divider"></div>
				<div class="description-section">
					<p class="description">{{ description }}</p>
					<button class="shop-button" @click="$emit('shop-click')">
						<span>{{ buttonText }}</span>
						<img :src="require('@/assets/arrow-right.png')" alt="arrow" class="arrow-icon" />
					</button>
				</div>
			</div>
		</div>
		<div class="stat-cards">
			<SavedToSpendStatCard
				:icon="require('@/assets/icons/coins-stacked.png')"
				:label="stat1Label"
				:value="formattedStat1"
				variant="gold"
			/>
			<SavedToSpendStatCard
				:icon="require('@/assets/icons/shopping-bag.png')"
				:label="stat2Label"
				:value="formattedStat2"
				variant="blue"
			/>
			<SavedToSpendStatCard
				:icon="require('@/assets/icons/credit-card-plus.png')"
				:label="stat3Label"
				:value="stat3Value"
				variant="purple"
			/>
		</div>
	</div>
</template>

<script>
import SavedToSpendStatCard from './SavedToSpendStatCard.vue';

export default {
	name: 'SavedToSpendBalance',
	components: { SavedToSpendStatCard },
	props: {
		title: {
			type: String,
			default: 'Your Saved to Spend pot'
		},
		balance: {
			type: Number,
			default: 0
		},
		description: {
			type: String,
			default: 'The cashback you have earned through buying vouchers will show here. you earn rewards when spending from your pot too!'
		},
		buttonText: {
			type: String,
			default: 'Shop'
		},
		stat1Label: {
			type: String,
			default: 'Saved in the\nlast year'
		},
		stat1Value: {
			type: Number,
			default: 0
		},
		stat2Label: {
			type: String,
			default: 'All time\nsavings'
		},
		stat2Value: {
			type: Number,
			default: 0
		},
		stat3Label: {
			type: String,
			default: 'Average\nreward'
		},
		stat3Value: {
			type: String,
			default: '0%'
		},
		formatter: {
			type: Object,
			default: () => ({ format: v => '£' + v.toLocaleString() })
		}
	},
	emits: ['shop-click'],
	computed: {
		formattedBalance() {
			return this.formatter.format(this.balance);
		},
		formattedStat1() {
			return this.formatter.format(this.stat1Value);
		},
		formattedStat2() {
			return this.formatter.format(this.stat2Value);
		}
	}
}
</script>

<style scoped>
.saved-to-spend-balance {
	display: flex;
	flex-direction: column;
	gap: 16px;
	width: 100%;
	background: var(--background-color-main);
	border-radius: 8px;
	padding: 16px;
}

.top-card {
	background: var(--background-color-main);
	border: 1px solid #FFFFFF;
	border-radius: 8px;
	padding: 24px 32px;
}

.main-content {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
}

.header-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 12px;
}

.title {
	font-size: 13px;
	line-height: 1.2;
	font-weight: bold;
	text-align: center;
	color: #413655;
	margin: 0;
}

.balance-row {
	display: flex;
	align-items: center;
	gap: 8px;
}

.balance-icon {
	width: 24px;
	height: 24px;
}

.balance {
	font-size: 24px;
	line-height: 1.2;
	font-weight: bold;
	text-align: center;
	color: #413655;
	margin: 0;
}

.divider {
	width: 100%;
	height: 1px;
	background: #DCDCDC;
}

.description-section {
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 16px;
	width: 100%;
}

.description {
	font-size: 11px;
	line-height: 1.1;
	text-align: center;
	color: #413655;
	margin: 0;
}

.shop-button {
	display: flex;
	align-items: center;
	gap: 4px;
	background: transparent;
	border: none;
	cursor: pointer;
	padding: 0;
}

.shop-button span {
	font-size: 13px;
	line-height: 1.2;
	font-weight: bold;
	color: #413655;
}

.arrow-icon {
	width: 12px;
	height: 12px;
}

.stat-cards {
	display: flex;
	gap: 12px;
}
</style>
